import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    // unsetting MUI5 styles
    '& .MuiButtonBase-root.MuiSwitch-switchBase:hover': {
      backgroundColor: 'unset',
    },
    // proper styles
    position: 'relative',
    boxSizing: 'content-box',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: 'auto',
    width: 'auto',
  },
  track: {
    display: 'flex',
    alignItems: 'center',
    height: idsTokens.switch.default.sizing.standard.switch.height,
    aspectRatio: '2 / 1',
    borderRadius: idsTokens.switch.default.radius.container,
    boxShadow: 'none',
    opacity: 1,
    boxSizing: 'border-box',
    // Smooth background changes on hover/press
    transition: 'background 150ms ease-out',
  },
  switchBase: {
    top: -5,
    left: -5,
    // Animate base toggle movement (spring-like)
    transition: 'transform 240ms cubic-bezier(0.2, 1, 0.3, 1)',
    // On
    '&.Mui-checked': {
      top: -5,
      left: 2,
      transform: 'translateX(24px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        background: idsTokens.switch.default.color.on.background.enabled,
        boxShadow: 'none',
      },
      '& .MuiSwitch-thumb': {
        boxShadow: 'none',
      },
      // On disabled
      '&.Mui-disabled': {
        opacity: 1,
        '& + .MuiSwitch-track': {
          opacity: 0.4,
          backgroundColor: idsTokens.switch.default.color.on.background.disabled,
          boxShadow: 'none',
        },
        '& .MuiSwitch-thumb': {
          color: idsTokens.switch.default.color.on.handle.disabled,
          boxShadow: 'none',
        },
      },
    },
    // disabled Off
    '&.Mui-disabled': {
      opacity: 1,
      '& + .MuiSwitch-track': {
        opacity: 0.4,
        backgroundColor: idsTokens.switch.default.color.off.background.disabled,
      },
      '& .MuiSwitch-thumb': {
        color: idsTokens.switch.default.color.off.handle.disabled,
        boxShadow: 'none',
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
    backgroundColor: idsTokens.switch.default.color.on.handle.enabled,
    boxShadow: 'none',
    // Spring-like motion for press (transform/width) and quick color/elevation
    transition:
      'transform 240ms cubic-bezier(0.2, 1, 0.3, 1), width 240ms cubic-bezier(0.2, 1, 0.3, 1), background 150ms ease-out, box-shadow 150ms ease-out',
  },
  sizeSmall: {
    padding: 0,
    width: 48,
    '& .MuiSwitch-track': {
      height: idsTokens.switch.default.sizing.small.switch.height,
      aspectRatio: '2 / 1',
      boxSizing: 'border-box',
    },
    '& .MuiSwitch-thumb': {
      width: 18,
      height: 18,
    },
    '& .MuiSwitch-switchBase': {
      padding: 1,
      top: 2,
      left: 2,
      // Ensure small variant also animates movement (spring-like)
      transition: 'transform 240ms cubic-bezier(0.2, 1, 0.3, 1)',
      '&.Mui-checked': {
        transform: 'translateX(24px)',
        top: 2,
      },
    },
  },
});
